'use no memo';
import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

import { i18n } from './utils/i18n.ts';

const DefaultPromptStyles = css({
	marginLeft: token('space.050'),
});

const AnimatedPromptStyles = css({
	WebkitBackgroundClip: 'text',
	backgroundClip: 'text',
	color: 'transparent',
	backgroundSize: '500%',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'@keyframes textShine': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'0%': {
			backgroundPosition: '0% 50%',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'100%': {
			backgroundPosition: '100% 50%',
		},
	},

	backgroundImage: `linear-gradient(
        to right,
		${token('color.text')} 20%,
		${token('color.text.subtle')} 40%,
        ${token('color.background.accent.gray.subtler')} 60%,
		${token('color.text.subtle')} 80%,
		${token('color.text')} 100%
    )`,
	animationDirection: 'reverse',
	animationName: 'textShine',
	animationDuration: '3s',
	animationIterationCount: '2',
	animationTimingFunction: 'ease-in-out',
	animationDelay: '2s',
});

type ReactionsPromptProps = {
	isPage: boolean;
	isDisabled: boolean;
	readOnly?: boolean;
	isHidden?: boolean;
	hasAnimation?: boolean;
};

export const ReactionsPrompt: FC<ReactionsPromptProps> = ({
	isPage,
	isDisabled,
	readOnly,
	isHidden,
	hasAnimation,
}) => {
	if (
		!isPage ||
		isHidden ||
		isDisabled ||
		readOnly ||
		fg('cc_page_experiences_new_editor_byline')
	) {
		return null;
	}

	return (
		<div
			css={[DefaultPromptStyles, hasAnimation && AnimatedPromptStyles]}
			data-testid={
				hasAnimation ? 'no-reactions-animated-text-prompt' : 'no-reactions-plain-text-prompt'
			}
		>
			<FormattedMessage {...i18n.noReactions} />
		</div>
	);
};
